/**
 * Encapsulates a redirect to the given route.
 */
function Redirect(to, params, query) {
  this.to = to;
  this.params = params;
  this.query = query;
}

module.exports = Redirect;



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-router/modules/utils/Redirect.js
 ** module id = 96
 ** module chunks = 0
 **/